import { render } from "./Uploader.vue?vue&type=template&id=e799729c"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__